﻿(function () {
    "use strict";

    angular.module("app").controller("TenantsController", TenantsController);

    TenantsController.$inject = ["ENV", "urlParameters"];

    function TenantsController(ENV, urlParameters) {
        let vm = this

        vm.params = urlParameters.get();
        vm.publicBucketName = ENV.publicBucketName;
    }
})();
